
export default class MarketerFormController {

	constructor (marketer, zones, Marketer, $state) {
		this.Marketer = Marketer;
		this.$state = $state;

		if (marketer) {
			this.mode = 'edit';
			this.marketer = marketer;
			this.allStoresUnsorted = marketer.zones.reduce((stores, zone) => stores.concat(zone.stores), []);
		} else {
			this.mode = 'create';
			this.marketer = { zones };
			this.allStoresUnsorted = zones.reduce((stores, zone) => stores.concat(zone.stores), []);
		}

		this.allStores = this.allStoresUnsorted.sort((s1, s2) => {
			if (s1.name > s2.name) {
				return 1;
			}
			if (s2.name > s1.name) {
				return -1;
			}
			return 0;
		});
	}

	back () {
		this.$state.go('marketersPage');
	}

	submit () {
		if (this.mode === 'edit') {
			this.Marketer.update(
				this.marketer.id,
				this.marketer
			).then(this.back.bind(this));
		}
		if (this.mode === 'create') {
			this.Marketer.create(
				this.marketer
			).then(this.back.bind(this));
		}
	}

}

MarketerFormController.$inject = ['marketer', 'zones', 'Marketer', '$state'];



// WEBPACK FOOTER //
// ./src/page/marketerForm/marketerForm.controller.js